module.exports = {"training":{"myCourse":"My Course","myCert":"My Cert","requestToJoin":"Request To Join","showDetail":"Detail","trainingList":"Training List","confirmMessage":"Are you sure to join this course?","date":"Date","confirmToJoin":"Confirm To Join","showCert":"Certificate","cert":"Certificate","speaker":"Speaker","alreadyInCourse":"Already Join","courseAvailableToJoin":"Course Available","history":"History","information":"Information","attachment":"Attachment","downloadUrl":"File Download","isAlreadyInCourse":"Already In Course","isAlreadyRequestToJoin":"Waiting Confirm","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/training.json
// module id = 552
// module chunks = 69